import { call, put, takeLatest } from "redux-saga/effects";
import { fetchUserProfileRequest, fetchUserProfileSuccess, fetchUserProfileFailure } from "../slice/userProfileSlice";
import { fetchUserProfileApi } from "@src/api/apiService"; // You need to implement this API call

export function* fetchUserProfile(): Generator<any, void, any> {
    try {
        const response = yield call(fetchUserProfileApi);
        yield put(fetchUserProfileSuccess(response.data));
    } catch (error: any) {
        yield put(fetchUserProfileFailure(error?.response?.data?.detail || error?.message || "Unknown error"));
    }
}

export function* userProfileSaga() {
    yield takeLatest(fetchUserProfileRequest.type, fetchUserProfile);
}
